var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-guides",
                              title: _vm.getTitle
                                ? `${_vm.getTitle} гид`
                                : `Создать гида`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "PageContent",
                                { attrs: { height: "85" } },
                                [
                                  _c("InputTitleSlug", {
                                    attrs: {
                                      "is-loading": _vm.loading || _vm.disabled,
                                      title: _vm.fields.name,
                                      "title-error": _vm.validationErrors.name,
                                      slug: _vm.fields.slug,
                                      "slug-error": _vm.validationErrors.slug,
                                      isSlugEnabled: !_vm.isNew,
                                    },
                                    on: {
                                      "change:title": function ($event) {
                                        _vm.fields.name = $event
                                      },
                                      "change:slug": function ($event) {
                                        _vm.fields.slug = $event
                                      },
                                      "input:slug": _vm.$v.fields.slug.$touch,
                                    },
                                  }),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v("Описание * ("),
                                              _c("TranslationIcon"),
                                              _vm._v(")"),
                                            ],
                                            1
                                          ),
                                          _c("v-textarea", {
                                            attrs: {
                                              id: "description",
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.validationErrors
                                                  .description,
                                            },
                                            on: {
                                              onChangeContent: function (
                                                $event
                                              ) {
                                                return _vm.$emit(
                                                  "change:descriptionForMobile",
                                                  $event
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.fields.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v("Краткое описание * ("),
                                              _c("TranslationIcon"),
                                              _vm._v(")"),
                                            ],
                                            1
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "shortDescription",
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.validationErrors
                                                  .shortDescription,
                                            },
                                            model: {
                                              value:
                                                _vm.fields.shortDescription,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "shortDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fields.shortDescription",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("MediaFilePicker", {
                                            attrs: {
                                              multiple: false,
                                              "file-type":
                                                _vm.$options.mediaTypesByKeys
                                                  .IMAGE,
                                              value: _vm.fields.imageId,
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.fields.imageId = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      !!_vm.routes
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Маршруты")]),
                                              _c("v-select", {
                                                attrs: {
                                                  multiple: "",
                                                  outlined: "",
                                                  "item-value": "id",
                                                  "item-text": "title",
                                                  items: _vm.routes,
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                },
                                                model: {
                                                  value: _vm.fields.routes,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "routes",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "fields.routes",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      !!_vm.audioguides
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Аудиогиды")]),
                                              _c("v-select", {
                                                attrs: {
                                                  multiple: "",
                                                  outlined: "",
                                                  "item-value": "id",
                                                  "item-text": "title",
                                                  items: _vm.audioguides,
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                },
                                                model: {
                                                  value: _vm.fields.audioguides,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "audioguides",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "fields.audioguides",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      !!_vm.cities
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("span", [_vm._v("Города")]),
                                              _c("v-select", {
                                                attrs: {
                                                  outlined: "",
                                                  "item-value": "id",
                                                  "item-text": "title",
                                                  items: _vm.cities,
                                                  disabled: _vm.disabled,
                                                  loading: _vm.loading,
                                                },
                                                model: {
                                                  value: _vm.fields.cityId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.fields,
                                                      "cityId",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "fields.cityId",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("SeoSettings", {
                                            attrs: {
                                              data: _vm.data,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              "on-input-seo": function (
                                                $event
                                              ) {
                                                _vm.fields = Object.assign(
                                                  {},
                                                  _vm.fields,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _vm.isNew
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isShowSortOrder: "",
                          "is-new": _vm.isNew,
                          "is-loading": _vm.loading,
                          "is-submit-disabled": _vm.disabled,
                          language: _vm.language,
                          translations: _vm.fields.translations,
                          "entity-id": _vm.data.id,
                          "entity-type": "guide",
                          sortOrder: _vm.fields.sortOrder,
                        },
                        on: {
                          cancel: function ($event) {
                            return _vm.$router.push({ name: "page-guides" })
                          },
                          submit: _vm.submit,
                          "update-translations": function ($event) {
                            return Object.assign(
                              _vm.fields.translations,
                              $event
                            )
                          },
                          "language-update": function ($event) {
                            return _vm.$emit("language-update", $event)
                          },
                          "update-sort-order": function ($event) {
                            _vm.fields.sortOrder = Number($event)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "info-append",
                              fn: function () {
                                return [
                                  _c("StatusPicker", {
                                    attrs: {
                                      align: "center",
                                      cols: "12",
                                      title: "Статус:",
                                      disabled: _vm.disabled,
                                      loading: _vm.loading,
                                      status: _vm.fields.status,
                                    },
                                    on: {
                                      "status:change": function ($event) {
                                        _vm.fields.status = $event
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2037224477
                        ),
                      })
                    : _vm.data
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isShowSortOrder: "",
                          "is-new": !_vm.data.id,
                          "created-at": _vm.data.createdAt,
                          "updated-at": _vm.data.updatedAt,
                          "is-loading": _vm.loading,
                          language: _vm.language,
                          translations: _vm.fields.translations,
                          "entity-id": _vm.data.id,
                          "entity-type": "guide",
                          sortOrder: _vm.fields.sortOrder,
                        },
                        on: {
                          delete: function ($event) {
                            return _vm.$emit("delete-guide")
                          },
                          cancel: function ($event) {
                            return _vm.$router.push({ name: "page-guides" })
                          },
                          submit: _vm.submit,
                          "update-translations": function ($event) {
                            return Object.assign(
                              _vm.fields.translations,
                              $event
                            )
                          },
                          "language-update": function ($event) {
                            return _vm.$emit("language-update", $event)
                          },
                          "update-sort-order": function ($event) {
                            _vm.fields.sortOrder = Number($event)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "info-append",
                            fn: function () {
                              return [
                                _c("StatusPicker", {
                                  attrs: {
                                    align: "center",
                                    cols: "12",
                                    title: "Статус:",
                                    disabled: _vm.disabled,
                                    loading: _vm.loading,
                                    status: _vm.fields.status,
                                  },
                                  on: {
                                    "status:change": function ($event) {
                                      _vm.fields.status = $event
                                    },
                                  },
                                }),
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [
                                        _vm._v("Посмотреть на сайте"),
                                      ]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              link: "",
                                              color: "primary",
                                              target: "_blank",
                                              href: _vm.redirectToWebPortal,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("mdi-web")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                !!_vm.fields.detailsEntityId
                                  ? _c(
                                      "v-row",
                                      { attrs: { align: "center" } },
                                      [
                                        _c("v-col", { attrs: { cols: "6" } }, [
                                          _c("span", [
                                            _vm._v("Посмотреть общий доступ"),
                                          ]),
                                        ]),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  link: "",
                                                  color: "primary",
                                                  to: _vm.redirectToSharedAccess,
                                                  loading: _vm.loading,
                                                  disabled: _vm.disabled,
                                                },
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-account-group"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("DetailComponent", {
                                          attrs: {
                                            loading: _vm.loading,
                                            disabled: _vm.disabled,
                                            "details-entity-id":
                                              _vm.fields.detailsEntityId,
                                            "details-entity-type":
                                              _vm.fields.detailsEntityType,
                                          },
                                          on: {
                                            "change:details-entity-type":
                                              function ($event) {
                                                return _vm.changeDetailsEntityType(
                                                  $event
                                                )
                                              },
                                            "change:details-entity-id":
                                              function ($event) {
                                                _vm.fields.detailsEntityId =
                                                  $event
                                              },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "body",
                            fn: function () {
                              return [
                                _vm.getEvents?.length ||
                                _vm.getAudioguides?.length ||
                                _vm.getRoutes?.length
                                  ? _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c(
                                          "v-card-subtitle",
                                          { staticClass: "grey--text" },
                                          [_vm._v("Связи")]
                                        ),
                                        _c(
                                          "v-card-text",
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c("RelationComponent", {
                                                  attrs: {
                                                    events: _vm.getEvents,
                                                    audioguides:
                                                      _vm.getAudioguides,
                                                    routes: _vm.getRoutes,
                                                    "shared-access":
                                                      _vm.sharedAccess,
                                                    "ticket-reservations":
                                                      _vm.ticketReservations,
                                                    name: _vm.getTitle,
                                                    loading: _vm.loading,
                                                    disabled: _vm.disabled,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }